import Listar from '@/pages/produto/unidadeMedida/Listar'

export const unidadeMedidaRoutes = [
    {
        path: '/unidade-medida',
        name: 'unidadeMedidas',
        component: Listar
    },
]

export default{}